<template>
  <el-config-provider :locale="localeLang">
    <router-view />
  </el-config-provider>
</template>
<script>
import { defineComponent, reactive, toRefs, computed } from 'vue'
import useAppStore from './store/modules/app'
import zh from 'element-plus/es/locale/lang/zh-cn'
import zhTw from 'element-plus/es/locale/lang/zh-tw'
import en from 'element-plus/es/locale/lang/en'
export default defineComponent({
    setup() {
        const appStore = useAppStore()
        const state = reactive({
        })

        const localeLang = computed(() => {
          const locale = appStore.locale;
          if(locale == "en"){
            return en;
          }else if(locale == "zhTw"){
            return zhTw;
          }else{
            return zh;
          }
        })

        // 优点：不用考虑适配问题，按设计稿进行固定尺寸开发
      function detectZoom() {
        let ratio = 0
        const screen = window.screen
        const ua = navigator.userAgent.toLowerCase()
        if (window.devicePixelRatio !== undefined) {
          ratio = window.devicePixelRatio
          // 兼容macos的视网膜屏参数，f*ck this
          if (/(mac os)/i.test(ua)) {
            ratio = 1
          }
        } else if (~ua.indexOf('msie')) {
          if (screen.deviceXDPI && screen.logicalXDPI) {
            ratio = screen.deviceXDPI / screen.logicalXDPI
          }
        } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
          ratio = window.outerWidth / window.innerWidth
        }
        return ratio
      }

        onMounted(() => {
          // 优点：不用考虑适配问题，按设计稿进行固定尺寸开发
          function bodyScale() {
            var devicewidth = document.documentElement.clientWidth;//获取当前分辨率下的可是区域宽度
            const detectZoomVal = detectZoom();
            let scale = 1;
            if(detectZoomVal > 1){
              scale = devicewidth*detectZoomVal*0.75 / 1920;
            }else{
              scale = devicewidth / 1920; // 分母——设计稿的尺寸
            }
            document.body.style.zoom = scale;// 放大缩小相应倍数
            appStore.SET_ZOOM(scale);

            const isChromeHighVersion = () => {
              const ua = navigator.userAgent.toLowerCase();
              const chromeIndex = ua.indexOf('chrome');
              if (chromeIndex > -1) {
                const version = ua.substring(chromeIndex + 7);
                const majorVersion = parseInt(version.split('.')[0], 10);
                return majorVersion > 127;
              }
              return false;
            };
            const originalGetBoundingClientRect = Element.prototype.getBoundingClientRect;
            if (!isChromeHighVersion()) {
              return;
            }
            Element.prototype.getBoundingClientRect = function () {
              const rect = originalGetBoundingClientRect.call(this);
              const zoom = Number(document.body.style.zoom || 1);
              const newRect = new DOMRect(
                  // 可自行修改
                  rect.x / zoom,
                  rect.y / zoom,
                  rect.width / zoom,
                  rect.height / zoom,
              );
              return newRect;
            };
          } 
          // bodyScale();
        })


        return {
            ...toRefs(state),
            localeLang
        }
    }
})
</script>